// extracted by mini-css-extract-plugin
export default {"etiqueta":"EtiquetaInvertir_etiqueta__l7e6p","box":"EtiquetaInvertir_box__k-qeE","vector":"EtiquetaInvertir_vector__28qET","text":"EtiquetaInvertir_text__DE4JT"};